/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Dashboard_Billing_Next_InvoiceInputs */



/**
* | output |
* | --- |
* | "Next invoice ≈ {total}" |
*
* @param {Dashboard_Billing_Next_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_next_invoice = /** @type {((inputs: Dashboard_Billing_Next_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Next_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nächste Rechnung ≈ ${i?.total}`)
	return /** @type {LocalizedString} */ (`Next invoice ≈ ${i?.total}`)
});